var _style, _g, _path, _rect, _path2, _path3, _polygon, _polygon2, _path4, _circle, _circle2, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDiscover(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#231F20;}\r\n\t.st1{fill:url(#XMLID_2_);}\r\n\t.st2{opacity:0.65;fill:url(#XMLID_3_);enable-background:new    ;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_35_"
  })), /*#__PURE__*/React.createElement("g", null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M23.15,215.18H0v81.08h23.15c12.2,0,21.18-2.95,28.9-9.4c9.26-7.72,14.73-19.22,14.73-31.14 C66.63,231.87,48.82,215.18,23.15,215.18z M41.66,276.06c-4.91,4.49-11.36,6.45-21.6,6.45h-4.21v-53.58h4.21 c10.24,0,16.41,1.82,21.6,6.59c5.47,4.91,8.7,12.34,8.7,20.2C50.36,263.43,47.13,271.15,41.66,276.06z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_422_",
    x: 73.92,
    y: 215.18,
    className: "st0",
    width: 15.85,
    height: 81.08
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_421_",
    className: "st0",
    d: "M128.35,246.32c-9.54-3.51-12.2-5.89-12.2-10.24c0-5.05,4.91-8.98,11.78-8.98 c4.77,0,8.56,1.96,12.76,6.59l8.28-10.8c-6.73-5.89-14.87-8.98-23.85-8.98c-14.31,0-25.25,9.96-25.25,23.15 c0,11.22,5.05,16.83,19.92,22.16c6.17,2.24,9.4,3.65,10.94,4.63c3.23,2.1,4.77,5.05,4.77,8.42c0,6.59-5.19,11.36-12.2,11.36 c-7.57,0-13.61-3.79-17.25-10.8l-10.24,9.82c7.29,10.66,15.99,15.43,28.05,15.43c16.41,0,27.91-10.94,27.91-26.65 C151.78,258.67,146.45,252.91,128.35,246.32z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_420_",
    className: "st0",
    d: "M156.69,255.72c0,23.85,18.66,42.22,42.78,42.22c6.73,0,12.62-1.4,19.78-4.77v-18.66 c-6.31,6.31-11.92,8.84-19.08,8.84c-15.85,0-27.21-11.5-27.21-27.91c0-15.57,11.64-27.77,26.51-27.77c7.57,0,13.19,2.67,19.78,9.12 v-18.66c-6.87-3.51-12.62-4.91-19.5-4.91C175.9,213.36,156.69,232.15,156.69,255.72z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_419_",
    className: "st0",
    points: "344.51,269.61 322.91,215.18 305.66,215.18 340.16,298.36 348.58,298.36  383.65,215.18 366.54,215.18  "
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_418_",
    className: "st0",
    points: "390.8,296.26 435.55,296.26 435.55,282.51 406.51,282.51 406.51,260.63  434.43,260.63 434.43,246.88 406.51,246.88 406.51,228.93 435.55,228.93 435.55,215.18 390.8,215.18  "
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M498.11,239.17c0-15.15-10.38-23.99-28.62-23.99h-23.43v81.08h15.85v-32.54h2.1l21.88,32.54h19.5l-25.53-34.09 C491.52,259.65,498.11,251.51,498.11,239.17z M466.41,252.49h-4.63v-24.55h4.91c9.82,0,15.15,4.07,15.15,12.06 C481.84,248.14,476.51,252.49,466.41,252.49z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "XMLID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 289.5718,
    y1: 870.554,
    x2: 259.7293,
    y2: 823.8295,
    gradientTransform: "matrix(1 0 0 1 0 -580)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F89F20"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2502,
    style: {
      stopColor: "#F79A20"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5331,
    style: {
      stopColor: "#F68D20"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6196,
    style: {
      stopColor: "#F58720"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7232,
    style: {
      stopColor: "#F48120"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F37521"
    }
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_415_",
    className: "st1",
    cx: 267.5,
    cy: 256,
    r: 43.06
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "XMLID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 284.8551,
    y1: 869.9166,
    x2: 241.2393,
    y2: 784.6673,
    gradientTransform: "matrix(1 0 0 1 0 -580)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F58720"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3587,
    style: {
      stopColor: "#E16F27"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.703,
    style: {
      stopColor: "#D4602C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9816,
    style: {
      stopColor: "#D05B2E"
    }
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_414_",
    className: "st2",
    cx: 267.5,
    cy: 256,
    r: 43.06
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_430_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M508.21,218.27c0-1.4-0.98-2.24-2.67-2.24h-2.24v7.15h1.68v-2.81l1.96,2.81h2.1l-2.38-2.95 C507.65,219.95,508.21,219.25,508.21,218.27z M505.27,219.25h-0.28v-1.82h0.28c0.84,0,1.26,0.28,1.26,0.98 C506.53,218.97,506.11,219.25,505.27,219.25z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M505.83,213.36c-3.51,0-6.17,2.81-6.17,6.17c0,3.51,2.81,6.17,6.17,6.17c3.37,0,6.17-2.81,6.17-6.17 S509.19,213.36,505.83,213.36z M505.83,224.72c-2.67,0-4.91-2.24-4.91-5.05s2.24-5.05,4.91-5.05c2.67,0,4.91,2.38,4.91,5.05 C510.74,222.47,508.49,224.72,505.83,224.72z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiscover);
export default __webpack_public_path__ + "static/media/discover.ca3da5e2e474d87c165925ad9ed5ef3e.svg";
export { ForwardRef as ReactComponent };